import { Flex, IconButton, Text } from "@chakra-ui/react";
import { FaQuestionCircle } from "react-icons/fa";
import * as React from "react";
import { useTranslation } from "react-i18next";

function RiskAssessment({ index, body }) {
  const { t } = useTranslation("translation", {
    keyPrefix: "supplierPhysicalRiskQuestionnaire"
  });

  return <Flex direction="column" gap={5}>
    <Flex justifyContent="space-between" alignItems="center">
      <Text fontWeight="semibold" fontSize="md">
        {t("riskAssessment.header")} {index}
      </Text>
      <IconButton
        type="button"
        icon={<FaQuestionCircle size="20" />}
        flexShrink="0"
        size="sm"
        opacity="0.25"
        tabIndex={-1}
      />
    </Flex>
    <Text opacity="0.75" fontSize="sm">
      {t(`riskAssessment.description${index}`)}
    </Text>
    {body}
  </Flex>;
}

export default RiskAssessment;